import { motion } from 'framer-motion';
import { FaInstagram, FaYoutube, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import './MadaraPage.css';

const MadaraPage = () => {
  const skills = [
  {
    category: 'Tournament Architecture',
    items: [
      'Large-Scale Format Design (256-Team Structures)',
      'Rulebook Development & Competitive Frameworks',
      'Bracket & Match Flow Structuring',
      'Prize Pool Planning & Allocation',
      'Competitive Integrity Oversight'
    ]
  },
  {
    category: 'Event Operations Lead',
    items: [
      'End-to-End Event Execution',
      'Admin & Staff Coordination',
      'Schedule & Timeline Management',
      'Live Issue Resolution',
      'Broadcast & Production Synchronization'
    ]
  },
  {
    category: 'Game Analysis',
    items: [
      'Draft Strategy & Counter-Pick Systems',
      'Macro Gameplay Optimization',
      'Meta & Patch Analysis',
      'Team Composition Structuring',
      'Performance Breakdown Reviews'
    ]
  },
  {
    category: 'Production Specialist',
    items: [
      'Content Planning & Structure',
      'Casting & Commentary Support',
      'Replay & Tactical Analysis',
      'Educational Content Development',
      'Workflow Optimization'
    ]
  },
  {
    category: 'Web Development',
    items: [
      'Tournament Website Architecture',
      'Registration System Integration',
      'Frontend Development (React + Vite)',
      'Admin Dashboard Structuring',
      'Performance Optimization'
    ]
  }
];


 const availability = [
  'Tournament Format Design & Architecture Consulting',
  'End-to-End Event Operations Management',
  'Esports Game Analysis & Strategic Breakdown',
  'Competitive Ecosystem Structuring',
  'Production & Broadcast Coordination Support',
  'Tournament Web Infrastructure Development'
];


  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <div className="madara-page">
      <section className="madara-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <motion.div
  className="hero-content"
  initial="hidden"
  animate="visible"
  variants={fadeIn}
>

  <div className="hero-left">
    <div className="profile-avatar">
      <div className="avatar-ring"></div>
      <img
        src="/argus_fem.png"
        alt="Madara In-Game Identity"
        className="avatar-image"
      />
    </div>
  </div>

  <div className="hero-center">
    <h1 className="profile-name">MADARA</h1>

    <p className="profile-tagline">
      Tournament Architect | Game Analyst<br />  Production Specialist | Web Developer <br /> Event Operations Lead
    </p>

    <p className="hero-proof">
      Architect of 256-Team Competitive Ecosystems · ₹100K+ Prize Pools Managed <br />in <br />The ashened cup
    </p>

    <div className="social-links">
      <motion.a href="https://www.instagram.com/madara_plays_mlbb"  target="_blank"
  rel="noopener noreferrer" className="social-link" whileHover={{ scale: 1.2 }}>
        <FaInstagram />
      </motion.a>
      <motion.a href="https://www.youtube.com/@madara_plays_mlbb"  target="_blank"
  rel="noopener noreferrer" className="social-link" whileHover={{ scale: 1.2 }}>
        <FaYoutube />
      </motion.a>
      <motion.a href="https://www.linkedin.com/in/tiwaridev"  target="_blank"
  rel="noopener noreferrer" className="social-link" whileHover={{ scale: 1.2 }}>
        <FaLinkedin />
      </motion.a>
    </div>
  </div>

</motion.div>

        </div>
      </section>

      <section className="section about-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="section-title">About</h2>
            <div className="about-content">
             <p>
              I design and oversee competitive esports ecosystems with a focus on operational precision 
              and scalable tournament infrastructure. From strategic format development to full-scale 
              event execution, I ensure competitive environments function at professional standards.
              </p>

              <p>
              My experience includes architecting 256-team tournament structures, coordinating 
              multi-layered administrative teams, managing prize pool ecosystems exceeding ₹100K, 
              and aligning production workflows for competitive broadcast delivery.
              </p>

              <p>
              Combining analytical game insight with structured operations management, I operate at 
              the intersection of strategy, execution, and systems architecture within the esports domain.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section skills-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="section-title">Professional Expertise</h2>
            
            <div className="skills-grid">
              {skills.map((skill, index) => (
                <motion.div
                  key={index}
                  className="skill-card card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                >
                  <h3 className="skill-category">{skill.category}</h3>
                  <ul className="skill-list">
                    {skill.items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section experience-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="section-title">Experience Highlights</h2>
            
            <div className="timeline">
              <motion.div 
                className="timeline-item"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
              >
                <div className="timeline-marker"></div>
                <div className="timeline-content card">
                  <h3>Tournament Architect</h3>
                  <p className="timeline-org">Liquid Fire Esports</p>
                  <p className="timeline-desc">
                    Designed and executed the Ashened Cup tournament structure, managing 256 teams 
                    and coordinating all operational aspects of the competitive ecosystem.
                  </p>
                </div>
              </motion.div>

              <motion.div 
                className="timeline-item"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
              >
                <div className="timeline-marker"></div>
                <div className="timeline-content card">
                  <h3>Lead Game Analyst</h3>
                  <p className="timeline-org">Professional Teams</p>
                  <p className="timeline-desc">
                    Provided in-depth draft analysis, meta breakdowns, and strategic planning for 
                    competitive teams, focusing on macro gameplay and team composition optimization.
                  </p>
                </div>
              </motion.div>

              <motion.div 
                className="timeline-item"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
              >
                <div className="timeline-marker"></div>
                <div className="timeline-content card">
                  <h3>Coach & Mentor</h3>
                  <p className="timeline-org">Various Teams & Players</p>
                  <p className="timeline-desc">
                    Individual and team coaching sessions focusing on skill development, 
                    communication improvement, and competitive mindset cultivation.
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section availability-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >

            <h2 className="section-title">Available for Professional Engagements</h2>
            <p className="availability-intro">
Available for structured engagements across tournament design, event operations,
competitive analysis, and digital infrastructure development. 
Open to collaborations with esports organizations, production houses, and competitive teams.
</p>
            <div className="availability-grid">
              {availability.map((item, index) => (
                <motion.div
                  key={index}
                  className="availability-item"
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <div className="check-icon">✓</div>
                  <p>{item}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section contact-section">
        <div className="container">
          <motion.div
            className="contact-cta"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="cta-title">Let's Collaborate</h2>
            <p className="cta-text">
              Interested in working together? Reach out to discuss coaching, 
              analysis, tournament organization, or production opportunities.
            </p>
                  <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=nt76746@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Initiate Collaboration
            </a>


          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MadaraPage;
